function main(): void {
  if (!customElements.get('image-switcher')) {
    customElements.define('image-switcher', ImageSwitcher);
  }
}

class ImageSwitcher extends HTMLElement {
  private interval: ReturnType<typeof setInterval> | null = null;

  connectedCallback() {
    const length = this.getElementsByTagName('img').length;

    if (length < 2) {
      return;
    }

    const intervalMs = Number(this.getAttribute('interval')) || 5000;

    this.interval = setInterval(() => {
      const index = Number(this.getAttribute('active-index')) || 0;
      const newIndex = (index + 1) % length;
      this.setAttribute('active-index', newIndex.toString());
    }, intervalMs);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

main();
